import { ReelSpin } from "./ReelSpin";
// import { Ui } from "../uiBGaming/Ui";

import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { BitmapText, Container } from 'pixi.js';
import { /*Tween,*/ Group, Tween } from "tweedle.js";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { /*SpinDataObject,*/ spinData, WinObject } from '../server/getServerResposesFun';

import {
    REEL_DIVIDER,
    REEL_NUMBERS,
    REEL_WIDTH,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL
} from "../config/reelConfig";

import { sound } from "@pixi/sound";
import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal, jurisdictionGlobal, RespinIndex } from "../config/GlobalVariableConfig";

// import { SETLINENUMBER } from "../config/customEvent";

const lineWinText = new BitmapText({
    text: '',
    style: {
        fontFamily: "dtt_coin_font",
        trim: true,
        fontSize: 90,
        // letterSpacing: 10,
    }

});

export interface CancellationToken {
    isCancelled: boolean;
}

const lineWinTextContainer = new Container();
const textTweenGroup = new Group();

export class ReelWin extends ReelSpin {


    private winSymbolArray: number[][] = [];

    public winLines: WinObject[] | null = null; // object for winning Lines 
    // private winScatters: WinObject[] | null = null; // object for winning Scatters 



    private winLinesSPine: Spine | null = null;
    private toggleWinLinesSpine: Spine | null = null;

    private currentAnimationCancellationToken: CancellationToken | null = null;

    constructor() {
        super();

        lineWinTextContainer.label = "lineWinTextContainer";

        // this.lineWinText.text = "";
        // this.lineWinText.style = style;

        // this.lineWinText.x = 500;
        // this.lineWinText.y = -100;

        // this.reelOverlayContainer.addChild(this.lineWinText);

        textTweenGroup.removeAll();

        this.setupLineWintext();

        // this.setWinLineSpineObj();

    }


    public updateReelWin() {
        this.updateReelSpin();

        textTweenGroup.update();

    }


    public async animateWinningSymbols(currentRespinIndex: number): Promise<void> {

        // console.log("inside animateWinningSymbols");

        this.setupLineWintext();

        this.setWinObjectsVal(currentRespinIndex);
        // this.setWinLineSpineObj();

        // this pause is mandatory to settle all reels, and observe the landing animations before starting next spin, specially in auto play
        if (spinData.respins[currentRespinIndex].winAmount == 0) {
            // console.log("no win");

            // await this.waitFunction(500);

            this.running = false;

            return Promise.resolve();
        }



        // console.log(this.spinData.winScatters);




        // if (winLines?.length == 0 && winScatters?.length == 0) {

        //     this.running = false;
        //     console.log(`running ${this.running}`);
        // }

        this.initWinSymbolArray();


        this.winLines?.forEach((winLine) => {

            const winlines: WinObject[] = [];
            winlines.push(winLine)

            this.setWinSymbolArray(winlines);
        })


        // Uncomment once the backend is fixed
        // this.winScatters?.forEach((winScatter) => {

        //     const winScatters : WinObject[] = [];
        //     winScatters.push(winScatter)

        //     this.setWinSymbolArray(winScatters);
        // })

        const winlineNumbers: number[] = this.getWinLineNmubers();

        // setWinSymbolArray

        console.log(winlineNumbers);


        // await this.animateWinningLines(winlineNumbers);

        // await this.makeNonwinSymbolDark();

        // await this.waitFunction(500),

        console.log("all line animations are completed");

        // return this.totalWin;

        // await this.lineLoggle(currentRespinIndex);



    }

    // this is main function which is doing the animation -
    public async animateAllWinningSymbols(currentRespinIndex: number): Promise<void> {

        return new Promise(async (resolve) => {

            if (spinData.respins[currentRespinIndex].winAmount == 0) {
                // this.running = false;
                resolve();
            }
            else {

                //  this.setWinSymbolArray(this.winScatters);

                this.winLines = spinData.respins[currentRespinIndex].winLines;
                if (!this.winLines) {
                    resolve();
                    return;
                }

                const winSymbolIds = [...new Set(this.winLines.map(line => line.symbolId))];

                for (let i = 0; i < winSymbolIds.length; i++) {
                    const symbolId = winSymbolIds[i];

                    const matchingWinLines = this.winLines.filter(line => line.symbolId === symbolId);
                    const winlineNumbers: number[] = [...new Set(matchingWinLines.map(line => line.lineId))];

                    let winAmount = 0;
                    matchingWinLines.forEach((winLine) => {
                        winAmount = winAmount + winLine.winAmount;
                    })

                    this.initWinSymbolArray();
                    this.setWinSymbolArray(matchingWinLines);

                    const winMultiplier = matchingWinLines[0].winMultiplier;

                    await this.animateWinLine(winlineNumbers, winAmount, winMultiplier);

                    if (winSymbolIds.length > 1) {

                        if (!isSuperQuickBtnOnGlobal && !isQuickBtnOnGlobal) {
                            await new Promise((resolve) => setTimeout(resolve, 200));
                        }
                    }
                }

                //animate win scatters
                // this.winScatters = spinData.respins[currentRespinIndex].winScatters;

            }

            console.log("all line animations are completed");
            this.resetSymbolLayer();

            resolve();
        })
    }

    public resetReelOverlayContFromToggle() {
        // this.toggleWinLinesSpine!.state.clearTracks();
        this.toggleOverlayContainer.removeChild(this.toggleWinLinesSpine);
        this.toggleOverlayContainer.removeChild(lineWinTextContainer);

        this.reelOverlayContainer.removeChild(this.winLinesSPine);
        this.reelOverlayContainer.removeChild(lineWinTextContainer);
        if (this.currentAnimationCancellationToken !== null)
            this.currentAnimationCancellationToken.isCancelled = true;
    }

    public resetWinsOnBetChange() {
        this.winLines = [];
        this.resetReelOverlayContFromToggle();
    }

    public async lineToggle2(currentRespinIndex: number) {
        if (this.running) return;

        console.log("inside lineToggle");
        this.winLines = spinData.respins[currentRespinIndex].winLines;
        if (!this.winLines) return;

        // --- CANCELLATION STEP 1: Create a new token for this sequence ---
        const token: CancellationToken = { isCancelled: false };
        this.currentAnimationCancellationToken = token;

        try {
            do {
                for (const winLine of this.winLines) {
                    if (!winLine || this.winLines.length <= 0) return;

                    // Add a check here as well if waitFunction is long/interruptible
                    await this.wait(this.winLines.length > 1 ? 1000 : 2000);

                    if (this.running || this.winLines.length <= 0 || token?.isCancelled) {
                        return; // Check cancellation flag here too
                    }

                    //const lineId = winLine.lineId;
                    const winAmount = winLine.winAmount;
                    const winMultiplier = winLine.winMultiplier;

                    this.toggleOverlayContainer.addChild(this.toggleWinLinesSpine);
                    this.toggleOverlayContainer.addChild(lineWinTextContainer);

                    lineWinTextContainer.y = 1080 / 2; //(0.5 + linesConfigGlobal[lineId][2]) * SYMBOL_HEIGHT;

                    // --- CANCELLATION STEP 2: Pass the token to the animation function ---
                    await Promise.all([
                        // this.playWinLineAnimationsToggle([lineId], 1, token), // Pass the token here
                        this.updateNumberText(winAmount / winMultiplier, winMultiplier, true),
                    ]);

                    // Break immediately if the next spin is called OR if cancelled
                    if (this.running || this.winLines.length <= 0 || token?.isCancelled) {
                        return;
                    }
                }

            } while (!this.running && this.winLines.length > 0 && !token?.isCancelled);
            // Add token check to loop condition

        } catch (reason) {
            if (reason === 'cancelled') {
                console.log("lineToggle sequence exited silently due to cancellation.");
            } else {
                console.error("An unexpected error occurred:", reason);
                throw reason;
            }
        } finally {
            // --- CANCELLATION STEP 3: Cleanup the token reference ---
            if (this.currentAnimationCancellationToken === token) {
                this.currentAnimationCancellationToken = null;
            }
        }
    }

    public async processWinFeatureSymbol(currentRespinIndex: number): Promise<void> {


        // let currentRespinIndex: number = 0;//spinData.respins.length-1;
        console.log("inside processWinFeatureSymbol", currentRespinIndex, spinData.respins[currentRespinIndex - 1]);
        const winScatter = spinData.respins[currentRespinIndex - 1].winScatters ? spinData.respins[currentRespinIndex - 1].winScatters[0] : null;
        if (winScatter == null) return;
        console.log("inside processWinFeatureSymbol", winScatter);


        // sound.play('scatter_win', { volume: 0.7 })

        this.initWinSymbolArray();


        if (winScatter) {
            const winScatters: WinObject[] = [];
            winScatters.push(winScatter);

            this.setWinSymbolArray(winScatters);

            let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

            sound.play('Scatter_Trigger', { speed: timeScale });
            await this.animateWinningLines([]);
        }

    }
    private async animateWinningLines(winlineNumbers: number[], winAmt?: number, currentMult?: number): Promise<void> {
        // If winAmt is 0, resolve the promise immediately
        if (winAmt === 0) {
            return Promise.resolve();
        }

        // Clear any existing tracks
        this.winLinesSPine?.state.clearTracks();

        // Set paying line (numbers) - animations for each winning line
        for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
            const winLineId = winlineNumbers[currentLineIndex];
            const winAnimationName = `payline_${winLineId}`;
            this.winLinesSPine?.state.setAnimation(currentLineIndex, winAnimationName, false); // Play the animation once
        }

        // Handle winning symbols
        this.winningSymbolOnTop();

        // Add the win lines spine to the overlay container if there are winning lines
        if (winlineNumbers.length > 0 && this.winLinesSPine) {
            this.reelOverlayContainer.addChild(this.winLinesSPine);
        }

        // Initialize text animation if winAmt is non-zero
        // let textanimate: TextAnimate | null = null;
        if (winAmt) {
            // const texttickupDuration = 0;
            // const textanimationDuration = 500;
            // const decimalPlace = 2;


            const textAnimationY = this.getTextAnimatePos();
            lineWinTextContainer.y = textAnimationY * 0.75;


            // Run both updateNumberText and runAnimation concurrently
            await Promise.all([
                this.runAnimation(),
                this.updateNumberText(winAmt / currentMult, currentMult),
            ]);

        }
        else {
            await this.runAnimation();
        }

        this.resetSymbolLayer();

    }

    private resetSymbolLayer() {
        // adjust the layering
        this.allReelArray.forEach((reelObj) => {
            reelObj.symbols.forEach((symbol) => {
                reelObj.container.addChild(symbol.view);
            })
        })
        console.log("reel reset after spin")
    }

    /*********************** Line Toggle ******************** */
    private async processWinObjectsToggel(winObjects: WinObject[] | null, winSymbolIds: number[], currentIndex: number, isLine: boolean): Promise<void> {
        if (winObjects?.length === 0) {
            // console.log(`No win ${isLine ? 'lines' : 'scatters'} to process.`);
            return;
        }

        if (winObjects === null) {
            return;
        }

        // Reset the index if it exceeds the length of winObjects
        if (currentIndex >= winObjects.length) {
            return;
        }

        // console.log(`toggelwin ${isLine ? 'lines' : 'scatters'} to process.`);
        // console.log(winObjects);

        const currentObjects: WinObject[] = [];
        let winAmt = 0;

        winObjects.forEach((winObject) => {
            if (winObject.symbolId === winSymbolIds[currentIndex]) {
                currentObjects.push(winObject);
                winAmt += winObject.winAmount;
            }
        })


        // console.log("processWinObjectsToggel", currentObjects);

        // const winSymbolPosistion = currentObject.winSymbolPosistions;
        // const winAmt = currentObject.winAmount;

        // console.log(winSymbolPosistion);
        // console.log(winAmt);

        // this.lineWinText.text = `${winAmt}`;


        // Reset original position
        // this.resetWinContainer();

        // Initialize winSymbolArray with zeros
        this.initWinSymbolArray();

        this.setWinSymbolArray(currentObjects);


        // console.log(winSymbolArray);

        const lineId = isLine ? winObjects[currentIndex].lineId : null;
        const winlineNumbers: number[] = [];
        if (lineId) {
            winlineNumbers.push(lineId);
        }

        const currentMult = winObjects[currentIndex].winMultiplier;

        await this.animateWinningLines(winlineNumbers, winAmt, currentMult);

        // await this.animateWinLinesSymbol(winSymbolArray, lineId, winLinesSPine, winAmt, true);

        // Move to the next index and call the function recursively
        await this.processWinObjectsToggel(winObjects, winSymbolIds, currentIndex + 1, isLine);
    }

    //@ts-ignore
    private isWinHigherBet: boolean = false;

    private async processAllRepeatedly(currentRespinIndex: number): Promise<void> {

        const winLines: WinObject[] | null = spinData.respins[currentRespinIndex].winLines;

        // Uncomment once the backend is fixed
        // const winScatters: WinObject[] | null = spinData.respins[currentRespinIndex].winScatters;

        // const currentMult: number = spinData.respins[currentRespinIndex].multiplier

        // map(line => line.lineId)

        this.isWinHigherBet = false; //spinData.respins[currentRespinIndex].isWinHigherBet

        const allWinSymbolIds = spinData.respins[currentRespinIndex].winLines?.map(line => line.symbolId) || [];   //[1, 2, 2, 3, 4, 4, 5];
        const winSymbolIds = allWinSymbolIds.filter((value, index, self) => self.indexOf(value) === index);


        // while (true) {
        if (winLines?.length ?? 0 > 0) {
            await this.processWinObjectsToggel(winLines, winSymbolIds, 0, true);
        }

        // Uncomment once the backend is fixed
        // if (winScatters?.length ?? 0 > 0) {
        //     await this.processWinObjectsToggel(winScatters, winSymbolIds,  0, currentMult, false);
        // }
        // }
    }

    private makeNonwinSymbolDark() {

        // const animationPromises: Promise<void>[] = [];


        let winSymbolFound = false;
        this.winSymbolArray.forEach((reels) => {
            reels.forEach((symbol) => {
                if (symbol != 0) {
                    winSymbolFound = true;
                }
            });
        });

        if (!winSymbolFound) {
            return;
        }

        // const colorOverlayFilter = new ColorOverlayFilter();
        // colorOverlayFilter.color = "#000000";
        // colorOverlayFilter.alpha = 0;

        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol === 0) { // non winning symbol which will be de-highlighted


                    let nonWinSymbol = this.allReelArray[reelNum].symbols[posNum].view;

                    // nonWinSymbol.filters = colorOverlayFilter;
                    nonWinSymbol.tint = "0x555555";


                }
            });
        });

        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();

        // if (!isFilterApplied) {
        //     this.resetAllSymbols();
        // }

        // if (animationPromises.length > 0) {
        //     await Promise.all(animationPromises);
        // }
        // else {

        //     this.resetAllSymbols();
        //     Promise.resolve();
        // }
        // Promise.resolve();
    }


    public async lineToggle(currentRespinIndex: number) {

        // await this.makeNonwinSymbolDark();



        console.log("inside lineToggle");


        // if (this.running == false) { // toggel animation

        // this.resetWinContainer();// reset symbols before line toggle
        // this.lineWinText.text = "";

        // Call the function to process both win lines and win scatters repeatedly

        if (spinData.respins[currentRespinIndex].winAmount > 0) {
            // await new Promise(resolve => setTimeout(resolve, 100));
            this.makeNonwinSymbolDark();

            await this.processAllRepeatedly(currentRespinIndex);



        }
        else {
            await new Promise(resolve => setTimeout(resolve, 100));
        }



        this.resetAllSymbols();

    }

    // private setWinLineSpineObj() {

    //     this.winLinesSPine = Spine.from({
    //         skeleton: "winLineSkel",
    //         atlas: "winLineAtlas",
    //     });

    //     this.winLinesSPine.state.clearTracks();

    //     this.reelOverlayContainer.addChild(this.winLinesSPine);

    //     this.toggleWinLinesSpine = Spine.from({
    //         skeleton: "winLineSkel",
    //         atlas: "winLineAtlas",
    //     });

    //     this.toggleWinLinesSpine.state.clearTracks();

    //     this.toggleOverlayContainer.addChild(this.toggleWinLinesSpine);

    // }

    private async wait(ms: number) {
        return new Promise((resolve) => {
            new Tween({})
                .delay(ms)
                .onAfterDelay(resolve) // Resolve the promise when delay ends
                .start();
        });
    }

    private initWinSymbolArray() {
        // Initialize winSymbolArray with zeros
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.winSymbolArray[i] = [];
            for (let j = 0; j < SYMBOLS_PER_REEL[i]; j++) {
                this.winSymbolArray[i][j] = 0; // Initialize to 0
            }
        }
    }


    private setWinSymbolArray(winObjects: WinObject[]) {
        // Iterate through winLines
        winObjects?.forEach((winObject) => {
            if (winObject.winSymbolPosistions) {
                // Adjust the type of reelNum and posNum to number

                winObject.winSymbolPosistions.forEach((winSymbolPosistion) => {

                    let reelNum: number = winSymbolPosistion[0];
                    let posNum: number = winSymbolPosistion[1];

                    if (this.reelSymbolsMapAfterJump[reelNum][posNum] >= 0) {

                        // this means this symbol has been replaced with wild, which can be find out by reelSymbolsMapAfterJump

                        const newPosNum = this.reelSymbolsMapAfterJump[reelNum][posNum];

                        posNum = newPosNum;
                    }


                    // Mark the position as 1
                    this.winSymbolArray[reelNum][posNum] = 1;
                })
            }
        });
    }


    private setWinObjectsVal(currentRespinIndex: number) {
        // this.setWinObjectsVal();
        this.winLines = spinData.respins[currentRespinIndex].winLines;

        // Uncomment once the backend is fixed
        // this.winScatters = spinData.respins[currentRespinIndex].winScatters;



        // console.log(spinData.respins[currentRespinIndex].winAmount);
        // this.totalWin = spinData.respins[currentRespinIndex].winAmount;
    }

    private getWinLineNmubers(): number[] {
        const winLineNmubers: number[] = [];//(number | null)[] | null  = null;  // define in a better way numbers[] | null

        this.winLines?.forEach((winLine) => {

            if (winLine.lineId) {
                winLineNmubers.push(winLine.lineId);
            }

        })

        // this.winlineNumbers = spinData.winLines?.map(line => line.lineId) ?? null; //[1, 2, 3]; // ?? null to change undefined value to null

        // when use in toggeling -> empty this array and push single line id, in the animation function use winlineNumbers.length

        return winLineNmubers;
    }

    private winningSymbolOnTop() {
        // this.reset
        // first take winning symbol on top

        // this.overlayConDarkLayer.visible = true;
        // this.reelOverlayContainer.addChild(this.overlayConDarkLayer);

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol == 1) // win animation
                {
                    // console.log(`reelNum ${reelNum}`);
                    // console.log(`posNum ${posNum}`);

                    // take them on top
                    const symbolCont = this.reelSymbolContainers[reelNum][posNum];
                    if (symbolCont) {
                        this.reelOverlayContainer.addChild(symbolCont);
                    }

                }
            })
        })

        // then take oversized symbol on top of that
        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol == 1) // win animation
                {
                    const symbolId: number = this.allReelArray[reelNum].symbols[posNum].id;

                    if (symbolId == 0) // symbolId of oversized symbols 
                    {
                        // take them on top
                        const symbolCont = this.reelSymbolContainers[reelNum][posNum];
                        if (symbolCont) {
                            this.reelOverlayContainer.addChild(symbolCont);
                        }

                    }
                }
            })
        })
    }


    // Function to calculate position based on lineNumber

    private resetAllSymbols() {

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {
                let symbol = this.reelSymbols[reelNum][posNum]
                symbol.tint = "0xffffff";
            }
        }
    }

    //@ts-ignore
    private playWinLineAnimations(winlineNumbers: number[], timeScale: number): Promise<void> {
        return new Promise((resolve) => {
            // Clear any existing tracks
            this.winLinesSPine?.state.clearTracks();

            const animationPromises: Promise<void>[] = [];

            // Set paying line animations for each winning line
            for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
                const winLineId = winlineNumbers[currentLineIndex];
                const winAnimationName = `payline_${winLineId}`;

                const animationPromise = new Promise<void>((resolve2) => {
                    let listener = {
                        complete: () => {
                            resolve2();
                            this.winLinesSPine!.state.removeListener(listener);
                        },
                    };
                    this.winLinesSPine!.state.addListener(listener);
                    this.winLinesSPine!.state
                        .setAnimation(currentLineIndex, winAnimationName, false);

                    this.winLinesSPine!.state.timeScale = timeScale;
                });

                animationPromises.push(animationPromise);
            }

            // Resolve when all animations complete
            Promise.all(animationPromises).then(() => resolve());
        });
    }

    //@ts-ignore
    // Add the CancellationToken parameter
    private playWinLineAnimationsToggle(winlineNumbers: number[], timeScale: number, token?: CancellationToken): Promise<void> {

        // We change resolve() to reject() as well, since Promise.all needs a rejection to stop immediately
        return new Promise((resolve, reject) => {
            // If already cancelled before we even start the animations, reject immediately
            if (token?.isCancelled) {
                return reject('cancelled');
            }

            this.toggleWinLinesSpine!.state.data.defaultMix = 0;
            this.toggleWinLinesSpine?.state.clearTracks();

            const animationPromises: Promise<void>[] = [];

            for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
                const winLineId = winlineNumbers[currentLineIndex];
                const winAnimationName = `payline_${winLineId}`;

                const animationPromise = new Promise<void>((resolve2, reject2) => { // Added reject2
                    let listener = {
                        complete: () => {
                            // --- CANCELLATION STEP 4: Check the token upon completion ---
                            if (token?.isCancelled) {
                                // Reject this inner promise if cancelled
                                reject2('cancelled');
                            } else {
                                // Otherwise, resolve normally
                                resolve2();
                            }
                            this.toggleWinLinesSpine!.state.removeListener(listener);
                        },
                    };

                    // Also check token immediately before setting animation if possible, 
                    // though the complete listener usually handles runtime cancellation well
                    if (token?.isCancelled) {
                        return reject2('cancelled');
                    }

                    this.toggleWinLinesSpine!.state.addListener(listener);
                    this.toggleWinLinesSpine!.state
                        .setAnimation(currentLineIndex, winAnimationName, false);
                    this.toggleWinLinesSpine!.update(0);
                    this.toggleWinLinesSpine!.state.timeScale = timeScale;
                });

                animationPromises.push(animationPromise);
            }

            // Resolve when all animations complete, or automatically reject if any single promise rejects
            Promise.all(animationPromises)
                .then(() => {
                    // Double check before resolving the master promise
                    if (token === null || !token?.isCancelled) {
                        resolve();
                    } else {
                        reject('cancelled');
                    }
                })
                .catch(reason => {
                    // Forward the rejection reason up to the caller (lineToggle's try/catch)
                    reject(reason);
                });
        });
    }

    //@ts-ignore
    private async runAnimation(winlineNumbers?: number[]): Promise<void> // play animation of symbols having value 1 in the array winSymbolArray
    {

        console.log("inside runAnimation");

        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        const animationPromises: Promise<void>[] = [];

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((value, posNum) => {
                let symbol = this.reelSymbols[reelNum][posNum]

                const symbolId = this.allReelArray[reelNum].symbols[posNum].id;

                if (value == 1) {
                    const animationPromise = new Promise<void>((resolve) => {

                        if (symbolId == GameConstants.SILVER_WILD_SYMOL_ID || symbolId == GameConstants.GOLDEN_WILD_SYMOL_ID) { // wild
                            let fDataDir;
                            if (symbolId === GameConstants.SILVER_WILD_SYMOL_ID) {
                                fDataDir = spinData.respins[RespinIndex.value].featureData?.nudgeInfo.find(nudge => nudge.reelNum === 0)?.dir;
                            } else {
                                fDataDir = spinData.respins[RespinIndex.value].featureData?.nudgeInfo.find(nudge => nudge.reelNum === 4)?.dir;
                            }

                            const winAnimationName = (fDataDir) ? ((fDataDir === "up") ? "win_up" : "win_down") : "win_up";
                            const idleAnimationName = (fDataDir) ? "idle_" + fDataDir : "idle_up";
                            sound.play('symbol_win', { volume: 0.4, speed: timeScale });
                            let listener = {
                                complete: () => {
                                    symbol.state.setAnimation(0, idleAnimationName, false);
                                    symbol.state.timeScale = 1;
                                    resolve();
                                    symbol.state.removeListener(listener);
                                }
                            };
                            symbol.state.addListener(listener);
                            symbol.state.setAnimation(0, winAnimationName, false);
                            symbol.state.timeScale = timeScale;
                        }
                        else {
                            let listener = {
                                complete: () => {
                                    resolve();
                                    symbol.state.removeListener(listener);
                                }
                            };
                            symbol.state.addListener(listener);
                            symbol.state.setAnimation(0, "win", false);
                            symbol.state.timeScale = timeScale;
                        }
                    })

                    animationPromises.push(animationPromise);
                }
                else {
                    symbol.tint = "0x555555";
                }
            }
            )
        })

        try {
            if (animationPromises.length > 0) {
                await Promise.all(animationPromises);
            }
        } catch (error) {
            console.error("Error during runAnimation:", error);
            throw error;
        }

    }


    private async animateWinLine(winlineNumbers: number[], winAmt?: number, currentMult?: number): Promise<void> {

        console.log("animateWinLine", winlineNumbers)
        // // If winAmt is 0, resolve the promise immediately
        // if (winAmt === 0) {
        //     return Promise.resolve();
        // }

        // Handle winning symbols
        this.winningSymbolOnTop();

        // Add the win lines spine to the overlay container if there are winning lines
        if (winlineNumbers.length > 0 && this.winLinesSPine) {
            this.reelOverlayContainer.addChild(this.winLinesSPine);
        }

        // on top of reelOverlayContainer
        this.reelOverlayContainer.addChild(lineWinTextContainer);

        // Initialize text animation if winAmt is non-zero
        // let textanimate: TextAnimate | null = null;
        if (winAmt) {
            // const texttickupDuration = 0;
            // const textanimationDuration = 500;
            // const decimalPlace = 2;


            const textAnimationY = this.getTextAnimatePos();
            lineWinTextContainer.y = textAnimationY * 0.75;

            await Promise.all([
                this.runAnimation(winlineNumbers),
                this.updateNumberText(winAmt / currentMult, currentMult)

            ]);

        }
        else {
            await this.runAnimation(winlineNumbers);
        }

        this.resetAllSymbols()

    }

    private setupLineWintext() {

        lineWinTextContainer.label = "lineWinTextContainer";
        lineWinText.anchor = 0.5;
        lineWinTextContainer.addChild(lineWinText);

        this.reelOverlayContainer.addChild(lineWinTextContainer);

        // new TextAnimate(textTweenGroup, winAmt, decimalPlace, texttickupDuration, textanimationDuration);
        lineWinTextContainer.x = (REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER[0]) / 2;


    }

    private getTextAnimatePos(): number {

        const mappedArray = this.winSymbolArray[0].map((_, colIndex) =>
            this.winSymbolArray.some(row => row[colIndex] === 1) ? 1 : 0
        );

        // Step 2: Get indexes with 1s
        const indexesWithOnes = mappedArray
            .map((value, index) => (value === 1 ? index : -1))
            .filter(index => index !== -1);

        // Step 3: Calculate Median
        let median: number;
        const len = indexesWithOnes.length;

        if (len === 0) {
            median = -1; // Handle case with no 1s
        } else if (len % 2 === 0) {
            median = (indexesWithOnes[len / 2 - 1] + indexesWithOnes[len / 2]) / 2;
        } else {
            median = indexesWithOnes[Math.floor(len / 2)];
        }

        // console.log("Mapped Array:", mappedArray);        // [1, 1, 1, 1, 1, 0]
        // console.log("Indexes with 1s:", indexesWithOnes); // [0, 1, 2, 3, 4]
        // console.log("Median index:", median);             // 2

        return (median + 0.5) * SYMBOL_HEIGHT;


    }

    // private getTextAnimatePos(lineNumber: number | null): number {

    //     // Define position configuration
    //     const positionConfig: Record<number, number> = {
    //         1: 0.5,
    //         2: 1.5,
    //         3: 2.5,
    //         4: 2.5,
    //         5: 0.5,
    //         6: 0.5,
    //         7: 2.5,
    //         8: 1.5,
    //         9: 1.5,
    //         10: 0.5,
    //         11: 2.5,
    //         12: 1.5,
    //         13: 1.5,
    //         14: 2.5,
    //         15: 0.5,
    //     };


    //     // Default position if lineNumber is not found in positionConfig
    //     let position = (SYMBOL_HEIGHT * 3) / 2;

    //     // Check if the lineNumber exists in positionConfig

    //     let offset;
    //     if (lineNumber == null) {
    //         // Retrieve offset from positionConfig
    //         offset = 1.5;
    //         position = offset * SYMBOL_HEIGHT;
    //     }
    //     else if (lineNumber in positionConfig) {
    //         // Retrieve offset from positionConfig
    //         offset = positionConfig[lineNumber];

    //     }
    //     else {
    //         offset = 1.5;
    //     }

    //     position = (offset + .25) * SYMBOL_HEIGHT;
    //     return position;
    // }

    private async updateNumberText(winAmt: number, currentMult?: number, callFromToggle: boolean = false): Promise<void> {
        // console.log(`currentMult ${currentMult}`);

        return new Promise(async (resolve) => {

            if (isSuperQuickBtnOnGlobal && !callFromToggle) {

                let targetVal: number = winAmt * currentMult;
                lineWinText.text = `${(targetVal).toFixed(2)}`;

                lineWinText.scale = 1;
                const textScale = Math.min(850 / lineWinText.width, 1);
                lineWinText.scale = textScale;

                if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                    // sound.play('symbol_win_multiply', { volume: 0 })
                }
                else {
                    if (callFromToggle !== true) {
                        sound.play('symbol_win', { volume: 0.4 })
                    }
                }

                await this.wait(500);

                lineWinText.text = "";
                lineWinText.scale = 1;

                await this.wait(100);

                resolve();

                return;
            }


            // if super turbo is not there

            if (currentMult && currentMult > 1) {
                lineWinText.text = `${winAmt.toFixed(2)} x ${currentMult}`;
            }
            else {
                lineWinText.text = `${winAmt.toFixed(2)}`;
            }

            lineWinText.scale = 1;
            const textScale = Math.min(850 / lineWinText.width, 1);
            lineWinText.scale = textScale;

            if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                // sound.play('symbol_win', { volume: 0 })
            }
            else {
                // sound.play('symbol_win', { volume: .3 })
                if (callFromToggle !== true) {
                    sound.play('symbol_win', { volume: .4 })
                }
            }

            await this.wait(500);

            if (currentMult && currentMult > 1) {

                let currentVal: number = winAmt;
                let targetVal: number = winAmt * currentMult;
                const tweenToTickup = new Tween({ x: currentVal }, textTweenGroup)
                    .to({ x: targetVal }, 100)
                    .onStart(() => {
                        // sound.play('symbol_win_multiply', { volume: 0.2 });

                        if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                            // sound.play('symbol_win_multiply', { volume: 0 })
                        }
                        else {
                            if (callFromToggle !== true) {
                                sound.play('symbol_win_multiply', { volume: 0.35 })
                            }
                        }
                    })
                    .onUpdate((object) => {
                        lineWinText.text = `${(currentVal).toFixed(2)}`;
                        currentVal = object.x; // Update currentVal with the tweened value
                        // console.log(`in tween currentVal: ${currentVal}`);
                    })
                    .onComplete(() => {
                        lineWinText.text = `${(targetVal).toFixed(2)}`;
                        textTweenGroup.remove(tweenToTickup)
                    })
                    .start();

                await this.wait(500);

            }
            else {
                await this.wait(500);
            }

            lineWinText.text = ``;
            lineWinText.scale = 1;

            resolve();
        })

    }

}